import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

/**
 * Specification of the fade duration given in milliseconds.
 */
const DURATION = 200;

type ThumbnailFadeProps = {
  children: (ref: RefObject<any>) => React.ReactNode;

  /**
   * Specifies if the fade-in transition should be disabled (ie. if the
   * element should do a hard appear).
   */
  disabled?: boolean;

  /**
   * Specifies if the element should be faded into view.
   */
  // tslint:disable-next-line no-reserved-keywords
  in?: boolean;
};

/**
 * Css fade transition that'll fade the block thumbnail into view, once the
 * required media has been fetched.
 */
// tslint:disable-next-line variable-name
export const ThumbnailFade: React.FC<ThumbnailFadeProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      classNames="progress__preview__thumbnailFade"
      timeout={{
        enter: props.disabled !== true ? DURATION : 0,
        exit: 0,
      }}
      mountOnEnter
      unmountOnExit
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          .progress__preview__thumbnailFade-enter {
            opacity: 0.001;
          }

          .progress__preview__thumbnailFade-enter-active {
            opacity: 1;
            transition: opacity ${DURATION}ms linear;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
